<template>
	<div
		class="player_selected h-full"
		:class="{
			selected: selected_player !== null,
		}"
		tabindex="0"
	>
		<div
			v-if="selected_player !== null"
			class="w-full player-viewer-card"
		>
			<div class="close-viewer" @click="close()">Close</div>
			<h4>
				{{ viewed_player.first_name }}
				{{ viewed_player.last_name }}
				<small>
					{{ viewed_player.jersey_number }} -
					{{ viewed_player.position }}
				</small>
			</h4>
			<div class="button-container">
				<PickPlayerButton
					:player="selected_player"
					:room_id="room_id"
				/>
				<QueuePlayerButton
					:player="selected_player"
					:room_id="room_id"
				/>
			</div>
		</div>
		<div v-else>Select a Player</div>
	</div>
</template>

<style lang="scss" scoped>
.close-viewer {
	@apply md:hidden;
}

.player_selected {
	@apply border-black border-l bg-gray-300;

	h4 {
		@apply flex-auto text-xl font-semibold;
	}

	.button-container {
		@apply flex w-full;

		button {
			@apply w-1/2 mx-2;
		}
	}
}

.player-viewer-card {
	@apply p-3;

	h4 {
		@apply text-xl;

		small {
			@apply text-sm;
		}
	}
}
</style>

<script>
import PickPlayerButton from '@/components/room/PickPlayerButton.vue';
import QueuePlayerButton from '@/components/room/QueuePlayerButton.vue';
import { mapState } from 'vuex';

export default {
	components: {
		PickPlayerButton,
		QueuePlayerButton,
	},
	computed: {
		...mapState({
			room_id: state => state.room.id,
			viewed_player: state => state.player.viewed_player,
		}),
	},
	props: {
		selected_player: null,
		close: null,
	},
};
</script>
